module.exports = __webpack_public_path__ + "media/guests/assets/images/face_document_image-2c7a685e100767162c7b4a5d8da2259e.jpg";